<template>
    <div class="stability-panel" :class="stability" v-if="stability">
        <h4 v-if="stability === 'stable'">Requested product is compatible</h4>
        <h4 v-if="stability === 'unstable'">Requested product is not compatible</h4>
        <h4 v-if="stability === 'unavailable'">Stability check not available</h4>
    </div>
</template>

<script>

export default {
    name: 'StabilityPanel',
    props: {
        stability: {
            required: true,
        },
    },
    data() {
        return {
        };
    },
    methods: {
    },
};
</script>
